<template>
    <form :id="id" @submit.prevent="handleSubmit" class="form-horizontal">
        <fieldset :disabled="disabled">
            <x-form-group
                label="Nama"
                :error="getError('label')"
                :isRequired="true"
            >
                <input
                    type="text"
                    class="form-control"
                    v-model="fields.label"
                    required
                />
            </x-form-group>

            <x-form-group
                label="Deskripsi"
                :error="getError('description')"
                :is-required="false"
            >
                <textarea class="form-control" v-model="fields.description" />
            </x-form-group>

            <x-form-group
                label="Users"
                :error="getError('user_ids')"
                :is-required="true"
            >
                <x-input-users
                    v-model="fields.user_ids"
                    :defaultParser="(data) => data.id"
                />
            </x-form-group>

            <x-form-group
                label="Kategori Group"
                :error="getError('category_ids')"
                :is-required="true"
            >
                <x-input-group-categories
                    v-model="fields.category_ids"
                    :defaultParser="(data) => data.id"
                />
            </x-form-group>
        </fieldset>
    </form>
</template>

<script>
import XAddItemButton from "../../components/XAddItemButton.vue";
import XDeleteItemButton from "../../components/XDeleteItemButton.vue";
import XFormGroup from "../../components/XFormGroup.vue";
import XInputGroupCategories from "../../components/XInputGroupCategories.vue";
import XInputUsers from "../../components/XInputUsers.vue";
import XTable from "../../components/XTable.vue";
import FormErrorMixin from "../../mixins/FormErrorMixin";

export default {
    components: {
        XFormGroup,
        XTable,
        XAddItemButton,
        XDeleteItemButton,
        XInputUsers,
        XInputGroupCategories,
    },
    created() {
        this.fields = {
            ...this.fields,
            ...this.initialFields,
        };
    },
    data() {
        return {
            fields: {
                label: null,
                description: null,
                user_ids: [],
                category_ids: [],
            },
        };
    },
    methods: {
        handleSubmit() {
            this.$emit("submit", { ...this.fields });
        },
    },
    mixins: [FormErrorMixin],
    props: {
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        errors: {
            type: Object,
            required: false,
            default: null,
        },
        id: {
            type: String,
            required: false,
            default: null,
        },
        initialFields: {
            type: Object,
            required: false,
            default: () => ({}),
        },
    },
};
</script>
